const rules = {
	user: {
		static: ["contacts-page:deleteContact"],
	},

	atendente: {
		static: ["contacts-page:deleteContact"],
	},

	arte_finalista: {
		static: ["contacts-page:deleteContact"],
	},

	financeiro: {
		static: [
			"dashboard:view",
			"contacts-page:deleteContact",
		],
	},

	supervisor: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			// LGPD/SEC-002: páginas com dados financeiros de todos os clientes
			"financial-pages:view",
			// LGPD/SEC-005: edição de dados fiscais (CPF/CNPJ/endereço)
			"contacts:editFiscalData",
		],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			"financial-pages:view",
			"contacts:editFiscalData",
		],
	},
};

export default rules;
